import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import ScrollToTop from "@/components/ScrollToTop";
import PublicLayout from "@/components/site/PublicLayout";
import MemberLayout from "@/components/member/MemberLayout";
import AdminLayout from "@/components/admin/AdminLayout";

import Home from "@/pages/Home";
import About from "@/pages/About";
import { BlogList, BlogPost } from "@/pages/Blog";
import { VideosList, VideoDetail } from "@/pages/Videos";
import { FiveThingsList, FiveThingsEpisode } from "@/pages/FiveThings";
import { EventsList, EventDetail } from "@/pages/Events";
import Membership from "@/pages/Membership";
import Book from "@/pages/Book";
import Press from "@/pages/Press";
import Contact from "@/pages/Contact";
import { Login, Register } from "@/pages/Auth";
import { CheckoutSuccess, CheckoutCancel } from "@/pages/Checkout";

import { MemberHome, MemberVideos, MemberEvents, MemberSaved, MemberResources, MemberQuestions, MemberAccount } from "@/pages/member/MemberPages";
import { AdminDashboard, BlogAdmin, VideosAdmin, SeriesAdmin, EventsAdmin, PlansAdmin, PressAdmin, ResourcesAdmin, DiscountsAdmin } from "@/pages/admin/AdminCrud";
import { MembersAdmin, RequestsAdmin, QuestionsAdmin, PaymentsAdmin, SubscribersAdmin, SettingsAdmin } from "@/pages/admin/AdminSpecial";
import { ReportsAdmin } from "@/pages/admin/Reports";

const PL = (el) => <PublicLayout>{el}</PublicLayout>;
const ML = (el) => <ProtectedRoute><MemberLayout>{el}</MemberLayout></ProtectedRoute>;
const AL = (el, adminOnly = false) => <ProtectedRoute roles={adminOnly ? ["admin"] : ["admin", "content_manager"]}><AdminLayout>{el}</AdminLayout></ProtectedRoute>;

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ScrollToTop />
        <Toaster position="top-right" richColors closeButton />
        <Routes>
          <Route path="/" element={PL(<Home />)} />
          <Route path="/about" element={PL(<About />)} />
          <Route path="/blog" element={PL(<BlogList />)} />
          <Route path="/blog/:slug" element={PL(<BlogPost />)} />
          <Route path="/videos" element={PL(<VideosList />)} />
          <Route path="/videos/:id" element={PL(<VideoDetail />)} />
          <Route path="/five-things" element={PL(<FiveThingsList />)} />
          <Route path="/five-things/:id" element={PL(<FiveThingsEpisode />)} />
          <Route path="/events" element={PL(<EventsList />)} />
          <Route path="/events/:id" element={PL(<EventDetail />)} />
          <Route path="/membership" element={PL(<Membership />)} />
          <Route path="/book" element={PL(<Book />)} />
          <Route path="/press" element={PL(<Press />)} />
          <Route path="/contact" element={PL(<Contact />)} />

          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/checkout/success" element={<CheckoutSuccess />} />
          <Route path="/checkout/cancel" element={<CheckoutCancel />} />

          <Route path="/member" element={ML(<MemberHome />)} />
          <Route path="/member/videos" element={ML(<MemberVideos />)} />
          <Route path="/member/events" element={ML(<MemberEvents />)} />
          <Route path="/member/saved" element={ML(<MemberSaved />)} />
          <Route path="/member/resources" element={ML(<MemberResources />)} />
          <Route path="/member/questions" element={ML(<MemberQuestions />)} />
          <Route path="/member/account" element={ML(<MemberAccount />)} />

          <Route path="/admin" element={AL(<AdminDashboard />)} />
          <Route path="/admin/members" element={AL(<MembersAdmin />, true)} />
          <Route path="/admin/blog" element={AL(<BlogAdmin />)} />
          <Route path="/admin/videos" element={AL(<VideosAdmin />)} />
          <Route path="/admin/series" element={AL(<SeriesAdmin />)} />
          <Route path="/admin/events" element={AL(<EventsAdmin />)} />
          <Route path="/admin/requests" element={AL(<RequestsAdmin />)} />
          <Route path="/admin/press" element={AL(<PressAdmin />)} />
          <Route path="/admin/resources" element={AL(<ResourcesAdmin />)} />
          <Route path="/admin/questions" element={AL(<QuestionsAdmin />)} />
          <Route path="/admin/plans" element={AL(<PlansAdmin />, true)} />
          <Route path="/admin/payments" element={AL(<PaymentsAdmin />, true)} />
          <Route path="/admin/discounts" element={AL(<DiscountsAdmin />, true)} />
          <Route path="/admin/subscribers" element={AL(<SubscribersAdmin />, true)} />
          <Route path="/admin/reports" element={AL(<ReportsAdmin />, true)} />
          <Route path="/admin/settings" element={AL(<SettingsAdmin />, true)} />

          <Route path="*" element={PL(<div className="brand-container py-32 text-center"><h1 className="brand-h1">404</h1><p className="brand-lede mt-4">This corner of the porch is empty. Try another door.</p></div>)} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
